import { useUserRewardsMe } from '@/api/user-rewards';
import { RewardId } from '@/enums/reward-id';
import { useMemo } from 'react';
import { useSearchParams } from './useSearchParams';

export function useLuckySpinWithSelectedSpin() {
  const search = useSearchParams();
  const mode = (search.get('mode') as string) ?? '1';

  const {
    rewards: luckySpins,
    error,
    isLoading,
    refetch,
  } = useUserRewardsMe({
    rewardId: RewardId.LuckyWheel,
  });

  const luckySpin = useMemo(
    () =>
      luckySpins?.find(luckySpin => Number(luckySpin?.spin) == Number(mode)),
    [mode, luckySpins],
  );

  return {
    mode,
    error,
    refetch,
    luckySpin,
    isLoading,
    luckySpins,
  };
}
